export default "__VITE_PUBLIC_ASSET__3af0bfd2__"